/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement } from 'react';
import { PickerInsideInput } from './components/PickerInsideInput/PickerInsideInput';
import Input from '~/view/components/Controls/InputComponent/Input';
import { IInputProps } from '~/view/components/Controls/InputComponent/types';
import { IPickerProps } from '~/view/components/Controls/Pickers/Picker/types';

interface IProps<T> extends IInputProps {
  pickerProps: IPickerProps<T>;
}

// eslint-disable-next-line unused-imports/no-unused-vars
const InputWithPickerInside = <T,>({ pickerProps, disableOnFocusOnInputWrapper, nextComponent, ...props }: IProps<T>): ReactElement => {
  return <Input {...props} disableOnFocusOnInputWrapper nextComponent={<PickerInsideInput {...pickerProps} />} />;
};

export default InputWithPickerInside;
